import React from 'react'
import Container from "react-bootstrap/Container";
import Row from "react-bootstrap/Row";
import Col from "react-bootstrap/Col";
import {ArrowLeftOutlined} from '@ant-design/icons'
import { useNavigate} from 'react-router-dom';


const InnerHeaderCheckout = () => {

  const navigate = useNavigate();


  return (
    <section className='header-car-booking-checkout'>
    <div className="bottom-nav ">
    <Container>
     <Row>
       <Col>
        <div className="checkout-heading-wrap ">
            <span  onClick={() => navigate(-1)}><ArrowLeftOutlined /></span>
            <div className='car-title'>Maruti Breeza</div>
            {/* <div className='display-date'>Sun, 26 Jun ‘22 <span> 8:30AM   :  </span>Sun, 26 Jun ‘22 <span> 9:30AM  </span></div> */}
        </div>
       </Col>
     </Row>
    </Container>
     </div>
     </section>
  )
}

export default InnerHeaderCheckout